import { ColumnDef } from '@tanstack/react-table'
import { Checkbox } from 'components/Checkbox'
import { TextCell } from 'components/table/cells/TextCell'
import { GeckoProcessFlowDiagram } from 'types'

interface ProcessFlowTableColumnsProps {
  selectedRows: Set<string>
  onRowSelection: (entryId: string, isSelected: boolean) => void
}

export const ProcessFlowTableColumns = <T extends GeckoProcessFlowDiagram>({
  selectedRows,
  onRowSelection,
}: ProcessFlowTableColumnsProps): ColumnDef<T>[] => [
  {
    id: 'select',
    header: '',
    enableSorting: false,
    cell: ({ row }) => (
      <Checkbox
        checked={selectedRows.has(row.original.id)}
        onCheckedChange={(checked) => {
          onRowSelection(row.original.id, !!checked)
        }}
        onClick={(event) => {
          event.stopPropagation()
        }}
      />
    ),
  },
  {
    id: 'name',
    accessorFn: (row) =>
      (row as GeckoProcessFlowDiagram).data?.metadata?.name ?? '',
    header: 'Name',
    cell: ({ row }) => <TextCell text={row.original.data?.metadata?.name} />,
  },
  {
    accessorKey: 'created_by',
    header: 'Created By',
    cell: ({ row }) => <TextCell text={row.original.created_by} />,
  },
  {
    accessorKey: 'updated_at',
    header: 'Last Modified',
    cell: ({ row }) => <TextCell text={row.original.updated_at} />,
  },
  {
    accessorKey: 'last_updated_by',
    header: 'Last Modified by',
    cell: ({ row }) => <TextCell text={row.original.last_updated_by} />,
  },
]
